<template>
  <div class="static-template">
    <div class="template-item" v-for="(item, index) in list" :key="index">
      <div class="tip" v-if="!item.hide">
        <div>
          {{ item.filedLabel }}
          <span v-if="item.isMust" class="weight">*</span>
        </div>
        <div style="color: #f5222d; margin: 5px 0px">{{ item.failReason }}</div>
      </div>
      <!-- 普通输入域 -->
      <div
        class="value"
        v-if="!item.hide && item.type === fieldType.Iconst_Input"
      >
        <span v-if="preview">{{
          childTaskDetail ? childTaskDetail[item.fieldName] : ""
        }}</span>
        <el-input v-else disabled size="small" placeholder="" />
      </div>
      <!-- 附件域 -->
      <div v-if="item.useDefaultFile && item.defaultValue">
        <div
          v-for="(fileItem, fileIndex) in getFileList(item)"
          :key="fileIndex"
        >
          <div @click="handlePreviewFile(fileItem)" class="file-item">
            {{ fileItem.name }}
          </div>
        </div>
      </div>
      <!-- 图片域 -->
      <div
        class="value"
        v-else-if="!item.hide && item.type === fieldType.Iconst_Pic"
      >
        <ossFileUpload
          v-if="preview"
          :value="fileList(item)"
          :ossUpload="true"
          :withCover="true"
          :disabled="true"
          :picSize="88"
          :listType="item.listType || 'picture-card'"
        />
        <div v-else class="pic-views">
          <div class="select-pic">
            <i class="el-icon-plus"></i>
            <span></span>
          </div>
          <!-- <div class="small-tip">单个图片/文件大小不超过300M</div>
          <div class="small-tip">支持格式：gif、png、jpg、jpeg、bmp</div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ossFileUpload from "@/components/ossFileUpload";
import { taskHelp, childTaskHelp } from "@/utils/viewHelp";
import { parseToUploadUrl } from "@/utils/oss";
import { cloneDeep } from "lodash";
export default {
  components: { ossFileUpload },
  props: {
    //是不是预览
    preview: {
      type: Boolean,
      default: false,
    },
    childTaskType: {
      type: Number,
      default: -1,
    },
    childTaskDetail: {
      type: Object | null,
      default: null,
    },
    childTaskAILogs: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      fieldType: childTaskHelp.fieldType,
      value: "",
    };
  },
  computed: {
    list() {
      if (this.childTaskType > 0) {
        const findedItem = taskHelp.taskTypeList.find(
          (item) => item.value === this.childTaskType
        );
        let temp = cloneDeep(findedItem.template);
        if (findedItem.value === 2) {
          //"学术培训"
          if (this.childTaskDetail.photoUrlSelected) {
            temp.forEach((item) => {
              if (item.fieldName === "trainCoursewareImgUrl") {
                item.defaultValue = [
                  JSON.parse(this.childTaskDetail.photoUrlSelected),
                ];
              }
            });
          }
        } else if (findedItem.value === 4) {
          // 终端开发
          temp.forEach((item) => {
            if (item.fieldName === "displayImgUrl") {
              if (this.childTaskDetail.custId == 4) {
                item.filedLabel = "医院准入证明文件";
              } else {
                item.filedLabel = "产品陈列图片";
              }
            }
          });
        }
        if (this.childTaskAILogs?.length > 0) {
          temp.forEach((item) => {
            this.childTaskAILogs.forEach((log) => {
              if (log.fieldCode === item.fieldName) {
                item["failReason"] = item["failReason"] = `${log.failReason}${
                  log.wordsFail || ""
                }`;
              }
            });
          });
        }
        return temp;
        // if (findedItem && Array.isArray(findedItem.template)) {
        //   return findedItem.template;
        // }
      }

      return [];
    },
  },
  methods: {
    getFileList(item) {
      const { defaultValue } = item;
      if (defaultValue) {
        return defaultValue;
      }
      return [];
    },
    handlePreviewFile(e) {
      const { name, value } = e;
      if (!value) {
        return;
      }
      window.open(value);
    },
    fileList(item) {
      if (this.childTaskDetail && this.childTaskDetail[item.fieldName]) {
        const imgUrl = this.childTaskDetail[item.fieldName];
        const urls = imgUrl.split("||");
        const picFileList = urls.map((item) => {
          return parseToUploadUrl(item);
        });
        return picFileList;
      }

      return [];
    },
  },
};
</script>
<style lang="scss" scoped>
.static-template {
  .template-item {
    .tip {
      font-size: 14px;
      color: #a0a0a0;

      .weight {
        color: #f00;
        position: relative;
        top: 4px;
        margin-left: 2px;
      }
      .logs {
        color: #f00;
        margin-left: 10px;
      }
    }

    .value {
      margin-top: 4px;
      color: #000;

      ::v-deep {
        .el-input {
          width: 100%;
        }
      }

      .pic-views {
        display: flex;
        flex-direction: column;

        .small-tip {
          font-size: 12px;
          color: #a0a0a0;
          margin-top: 12px;
        }
      }

      .select-pic {
        width: 110px;
        height: 110px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border: 1px dashed #f0f0f0;
        padding: 24px;
        box-sizing: border-box;
        border-radius: 4px;
      }
    }
  }

  .position {
    background: #eff3fd;
    padding: 12px;
    box-sizing: border-box;
    border-radius: 4px;
  }

  & > * {
    margin-bottom: 12px;
  }
  .file-item {
    font-size: 14px;
    line-height: 2;
    cursor: pointer;
    &:hover {
      color: #f00;
    }
  }
}
</style>
